import { Checkbox, CheckboxProps } from "antd";
import { FC, useCallback } from "react";
import { Point, TaskDMP, TaskDMPEntity, TaskStatus } from "tm-shared/types";

import { useCompleteTask } from "@/domains/tasks/hooks";
import { ForceStepComplete } from "@/features/ForceStepComplete";
import { useAppDispatch } from "@/hooks/redux";
import { useMakeCommand } from "@/hooks/requestQueue/useRequestQueue";
import { setMdTasksConfig } from "@/store/slices/ui";

import { StyledContainer } from "./Styled";

interface DMPControllerProps {
    point: Point;
    task: TaskDMP;
}

export const DMPController: FC<DMPControllerProps> = ({ point, task }) => {
    const dispatch = useAppDispatch();

    const pointId = point.id;
    const taskId = task.id;

    const onChange: CheckboxProps["onChange"] = (e) => {
        dispatch(
            setMdTasksConfig({
                pointId,
                taskId,
                field: "showUncompleted",
                value: e.target.checked,
            }),
        );

        dispatch(
            setMdTasksConfig({
                pointId,
                taskId,
                value: null,
            }),
        );
    };

    const { makeTaskCompleteCommands } = useMakeCommand();
    const completeTask = useCompleteTask({ targetId: pointId, taskId });

    const handleForceTaskComplete = useCallback(
        async (comment: string) => {
            const payload: Record<string, TaskDMPEntity> = {};

            task.context.dmp.forEach(({ subtaskId, contractId }) => {
                payload[subtaskId] = {
                    contractId,
                    comment,
                    status: TaskStatus.Rejected,
                };
            });

            const commands = await makeTaskCompleteCommands({
                params: { taskId, hasPhoto: false, payload },
            });

            completeTask({ commands });
        },
        [completeTask, makeTaskCompleteCommands, task.context.dmp, taskId],
    );

    return (
        <StyledContainer>
            <Checkbox onChange={onChange}>Показати невиконані</Checkbox>

            <ForceStepComplete
                onComplete={handleForceTaskComplete}
                taskName={task.name}
                pointName={point.name}
            />
        </StyledContainer>
    );
};
